module.exports = __webpack_public_path__ + "static/media/error.812b8a82.svg";